import {
	AuditOutlined,
	UserOutlined,
	CalendarOutlined,
	QuestionCircleOutlined,
	NotificationOutlined,
	PlayCircleOutlined,
	DollarOutlined,
	WhatsAppOutlined,
	MessageOutlined,
	FunnelPlotOutlined,
	FundProjectionScreenOutlined,
	HeartOutlined,
	TrophyOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH, PUBLIC_PREFIX_PATH } from "configs/AppConfig";
import {
	PermissaoGrupoUsuarioEnum,
	PermissaoUsuarioEnum,
	PermissaoAlimentoEnum,
	PermissaoFichaDietaEnum,
	PermissaoTecnicaExercicioEnum,
	PermissaoExercicioEnum,
	PermissaoFichaTreinoEnum,
	PermissaoTabelaSubstituicaoEnum,
	PermissaoQuestionarioDinamicoEnum,
	PermissaoConfiguracaoAppEnum,
	PermissaoCupomEnum,
	PermissaoPlanoContratualEnum,
	PermissaoGrupamentoMuscularEnum,
	PermissaoRefeicaoEnum,
	PermissaoTreinoPrecadastradoEnum,
	PermissaoFichaDietaPrecadastradaEnum,
	PermissaoMaterialEnum,
	PermissaoFuncionarioEnum,
	PermissaoGrupoFuncionarioEnum,
	PermissaoLogsEnum,
	PermissaoLogErroAppEnum,
	PermissaoDashboardAdminEnum,
	PermissaoNotificacaoPersonalizadaEnum,
	PermissaoModuloEnum,
	PermissaoPlanoProfissionalEnum,
	PermissaoFinanceiroEnum,
	PermissaoChatEnum,
	PermissaoCrmEnum,
	PermissaoGamificacaoEnum,
} from "enum/permissao-enum";

const dashBoardNavTree = [
	{
		key: "dashboard-profissional",
		path: `${APP_PREFIX_PATH}/dashboard-profissional`,
		title: "dashboard-profissional",
		icon: CalendarOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoUsuarioEnum.VISUALIZAR_TELA_ALUNOS,
	},
	// {
	// 	key: "dashboard",
	// 	path: `${APP_PREFIX_PATH}/dashboard`,
	// 	title: "Home",
	// 	icon: `${PUBLIC_PREFIX_PATH}/img/icon/home.png`,
	// 	breadcrumb: false,
	// 	submenu: [],
	// },
	{
		key: "dashboard-admin",
		path: `${APP_PREFIX_PATH}/dashboard-admin`,
		title: "dashboard-admin",
		icon: AuditOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoDashboardAdminEnum.VISUALIZAR,
	},
	{
		key: "dashboard-trafego",
		path: `${APP_PREFIX_PATH}/dashboard-trafego`,
		title: "dashboard-trafego",
		icon: FundProjectionScreenOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoDashboardAdminEnum.VISUALIZAR,
	},
	{
		key: "dashboard-financeiro",
		path: `${APP_PREFIX_PATH}/dashboard-financeiro`,
		title: "dashboard-financeiro",
		icon: DollarOutlined,
		breadcrumb: false,
		submenu: [],
		requireFinanceiroAtivo: true,
		permissao: PermissaoFinanceiroEnum.VISUALIZAR_DASHBOARD_FINANCEIRO,
	},
	{
		key: "chat",
		path: `${APP_PREFIX_PATH}/chat`,
		title: "chat",
		icon: MessageOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoChatEnum.VISUALIZAR_CHAT,
		indexNotificacoes: "chat",
	},
	{
		// Sempre visível, mesmo com o módulo desligado: a própria tela vira
		// o onboarding de ativação (idem ranking-gamificacao abaixo).
		key: "comunidade",
		path: `${APP_PREFIX_PATH}/comunidade`,
		title: "comunidade",
		icon: HeartOutlined,
		breadcrumb: false,
		submenu: [],
	},
	{
		key: "ranking-gamificacao",
		path: `${APP_PREFIX_PATH}/ranking-gamificacao`,
		title: "ranking-gamificacao",
		icon: TrophyOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoGamificacaoEnum.VISUALIZAR_RANKING,
	},
	{
		key: "whatsapp-chat",
		path: `${APP_PREFIX_PATH}/whatsapp-chat`,
		title: "whatsapp-chat",
		icon: WhatsAppOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoDashboardAdminEnum.VISUALIZAR,
	},
	{
		key: "crm",
		path: `${APP_PREFIX_PATH}/crm`,
		title: "crm",
		icon: FunnelPlotOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoCrmEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-usuarios",
		path: `${APP_PREFIX_PATH}/lista-usuarios`,
		title: "lista-usuarios",
		icon: UserOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoUsuarioEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-alunos",
		path: `${APP_PREFIX_PATH}/lista-alunos`,
		title: "lista-alunos",
		icon: `${PUBLIC_PREFIX_PATH}/img/icon/alunos.png`,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoUsuarioEnum.VISUALIZAR_TELA_ALUNOS,
	},
	{
		key: "lista-ficha-dieta",
		path: `${APP_PREFIX_PATH}/lista-ficha-dieta`,
		title: "lista-ficha-dieta",
		icon: `${PUBLIC_PREFIX_PATH}/img/icon/ficha-dieta.png`,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoFichaDietaEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-ficha-treino",
		path: `${APP_PREFIX_PATH}/lista-ficha-treino`,
		title: "lista-ficha-treino",
		icon: `${PUBLIC_PREFIX_PATH}/img/icon/ficha-treino.png`,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoFichaTreinoEnum.VISUALIZAR_TELA,
	},
	{
		key: "configuracao-app",
		path: `${APP_PREFIX_PATH}/configuracao-app`,
		title: "configuracao-app",
		icon: `${PUBLIC_PREFIX_PATH}/img/icon/configuracoes-app.png`,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoConfiguracaoAppEnum.VISUALIZAR_TELA,
	},
	{
		key: "notificacoes-personalizadas",
		path: `${APP_PREFIX_PATH}/notificacoes-personalizadas`,
		title: "notificacoes-personalizadas",
		icon: NotificationOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoNotificacaoPersonalizadaEnum.VISUALIZAR_TELA,
	},
	{
		key: "aulas",
		path: `${APP_PREFIX_PATH}/aulas`,
		title: "aulas",
		icon: PlayCircleOutlined,
		breadcrumb: false,
		submenu: [],
		// Disponível para todos os usuários logados
	},
	{
		key: "ajuda",
		path: `${APP_PREFIX_PATH}/ajuda`,
		title: "ajuda",
		icon: QuestionCircleOutlined,
		breadcrumb: false,
		submenu: [],
		// Sem permissão específica - disponível para todos
	},
	{
		showTitle: false,
		title: "secundario",
		submenu: [
			{
				key: "cadastro-secundario",
				title: "cadastro-secundario",
				breadcrumb: false,
				icon: `${PUBLIC_PREFIX_PATH}/img/icon/cadastro-secundario.png`,
				submenu: [
					{
						key: "lista-grupos-usuario",
						path: `${APP_PREFIX_PATH}/lista-grupos-usuario`,
						title: "lista-grupos-usuario",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoGrupoUsuarioEnum.VISUALIZAR,
					},
					{
						key: "lista-exercicio",
						path: `${APP_PREFIX_PATH}/lista-exercicio`,
						title: "lista-exercicio",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoExercicioEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-treino-precadastrado",
						path: `${APP_PREFIX_PATH}/lista-treino-precadastrado`,
						title: "lista-treino-precadastrado",
						breadcrumb: false,
						submenu: [],
						permissao:
							PermissaoTreinoPrecadastradoEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-alimento",
						path: `${APP_PREFIX_PATH}/lista-alimento`,
						title: "lista-alimento",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoAlimentoEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-tabela-substituicao",
						path: `${APP_PREFIX_PATH}/lista-tabela-substituicao`,
						title: "lista-tabela-substituicao",
						breadcrumb: false,
						submenu: [],
						permissao:
							PermissaoTabelaSubstituicaoEnum.VISUALIZAR_TELA,
					},
					{
						key: "refeicao",
						path: `${APP_PREFIX_PATH}/lista-refeicao`,
						title: "refeicao",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoRefeicaoEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-ficha-dieta-precadastrada",
						path: `${APP_PREFIX_PATH}/lista-ficha-dieta-precadastrada`,
						title: "lista-ficha-dieta-precadastrada",
						breadcrumb: false,
						submenu: [],
						permissao:
							PermissaoFichaDietaPrecadastradaEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-tecnica-exercicio",
						path: `${APP_PREFIX_PATH}/lista-tecnica-exercicio`,
						title: "lista-tecnica-exercicio",
						breadcrumb: false,
						submenu: [],
						permissao:
							PermissaoTecnicaExercicioEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-questionario-dinamico",
						path: `${APP_PREFIX_PATH}/lista-questionario-dinamico`,
						title: "lista-questionario-dinamico",
						breadcrumb: false,
						submenu: [],
						permissao:
							PermissaoQuestionarioDinamicoEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-material",
						path: `${APP_PREFIX_PATH}/lista-material`,
						title: "lista-material",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoMaterialEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-plano-contratual",
						path: `${APP_PREFIX_PATH}/lista-plano-contratual`,
						title: "lista-plano-contratual",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoPlanoContratualEnum.VISUALIZAR,
					},
					{
						key: "lista-planos-profissional",
						path: `${APP_PREFIX_PATH}/lista-planos-profissional`,
						title: "lista-planos-profissional",
						breadcrumb: false,
						submenu: [],
						permissao:
							PermissaoPlanoProfissionalEnum.VISUALIZAR_TELA,
						requireFinanceiroAtivo: true,
					},
					{
						key: "lista-cupom",
						path: `${APP_PREFIX_PATH}/lista-cupom`,
						title: "lista-cupom",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoCupomEnum.VISUALIZAR,
					},
					{
						key: "lista-oferta",
						path: `${APP_PREFIX_PATH}/lista-oferta`,
						title: "lista-oferta",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoDashboardAdminEnum.VISUALIZAR,
					},
					{
						key: "lista-grupamentos-musculares",
						path: `${APP_PREFIX_PATH}/lista-grupamentos-musculares`,
						title: "lista-grupamentos-musculares",
						breadcrumb: false,
						submenu: [],
						permissao:
							PermissaoGrupamentoMuscularEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-audit-logs",
						path: `${APP_PREFIX_PATH}/lista-audit-logs`,
						title: "lista-audit-logs",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoLogsEnum.VISUALIZAR_AUDIT_LOGS,
					},
					{
						key: "lista-activity-logs",
						path: `${APP_PREFIX_PATH}/lista-activity-logs`,
						title: "lista-activity-logs",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoLogsEnum.VISUALIZAR_ACTIVITY_LOGS,
					},
					{
						key: "lista-log-erro-app",
						path: `${APP_PREFIX_PATH}/lista-log-erro-app`,
						title: "lista-log-erro-app",
						icon: AuditOutlined,
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoLogErroAppEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-funcionarios",
						path: `${APP_PREFIX_PATH}/lista-funcionarios`,
						title: "lista-funcionarios",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoFuncionarioEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-grupos-funcionario",
						path: `${APP_PREFIX_PATH}/lista-grupos-funcionario`,
						title: "lista-grupos-funcionario",
						breadcrumb: false,
						submenu: [],
						permissao:
							PermissaoGrupoFuncionarioEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-modulos",
						path: `${APP_PREFIX_PATH}/lista-modulos`,
						title: "lista-modulos",
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoModuloEnum.VISUALIZAR_TELA,
					},
				],
			},
		],
	},
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
